import { LinkWithReferrer } from '@components/common/helpers/link';

import { css } from '@emotion/css'
import { mobileOnly } from '@styles/breakpoints';
import colors from '@styles/colors';

import BgDesktop from '@img/yotpo/referral-banner-desktop.jpg';
import BgMobile from '@img/yotpo/referral-banner-mobile.jpg';
import ArrowRight from '@components/common/presentational/svg/arrow-right';

const styles = css({
    width: '100%',
    padding: 40,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center,center',
    backgroundImage: `url(${BgDesktop})`,
    backgroundSize: 'cover',
    borderRadius: '5px',

    '.text': {
        color: colors.NAVY,
        marginBottom: 35,
        fontSize: 24,
        fontWeight: 800,
        lineHeight: '135%',
        letterSpacing: '0.02em',
        width: '100%',
        maxWidth: 420,

    },

    a: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textDecoration: 'none',
        color: colors.BLUE,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: '0.02em',
        textTransform: 'uppercase',

        svg: {
            marginLeft: 8
        }
    },

    [mobileOnly]: {
        backgroundImage: `url(${BgMobile})`,
        height: 360,

        '.text': {
            marginBottom: 18,
            fontSize: 22,
            fontWeight: 700,
        },
    },

});

export default function ReferralBanner() {
    return (
        <div className={`${styles} referral-wrapper`}>
            <div className="text">
                Refer a friend and get $20 off your next box!
            </div>
            <LinkWithReferrer to={'/referral'}>
                Get your CODE <ArrowRight stroke={colors.BLUE} />
            </LinkWithReferrer>
        </div>
    );
}